(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormController', EventFormController);

    EventFormController.$inject = ['$scope', '$state', 'EventForm', 'ParseLinks', '$filter', 'AlertService', 'EventFormCategory', 'pagingParams', 'paginationConstants', 'Principal', '$window', '$uibModal', '$translate'];

    function EventFormController($scope, $state, EventForm, ParseLinks, $filter, AlertService, EventFormCategory, pagingParams, paginationConstants, Principal, $window, $uibModal, $translate) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.updateSubCategory = updateSubCategory;
        vm.updateAreaFilter = updateAreaFilter;
        vm.statusLabel = statusLabel;
        vm.searchText = $state.params.searchText;
        vm.workflowStatus = $state.params.workflowStatus || null;
        vm.listSubCategory = [];
        vm.listAgency = [];
        vm.listArea = [];
        vm.allAreas = [];
        vm.selected = {};
        vm.allMatching = false;
        vm.bulkStatuses = [];
        vm.selectedCount = selectedCount;
        vm.togglePage = togglePage;
        vm.toggleMatching = toggleMatching;
        vm.changeStatuses = changeStatuses;
        vm.openBulkStatus = openBulkStatus;
        vm.showWorkflowHelp = function() {
            $uibModal.open({templateUrl: 'eventWorkflowHelp.html', size: 'sm'});
        };
        var loadedFilters;
        var selectionFilters;
        var bulkModal;

        vm.date = {
            startDate: $state.params.startDate ? new Date($state.params.startDate) : null,
            endDate: $state.params.endDate ? new Date($state.params.endDate) : null
        };

        if ($state.params.categoryId) {
            vm.category = {id: $state.params.categoryId};
            vm.updateSubCategory();
        }
        if ($state.params.subCategoryId) {
            vm.subCategory = {id: $state.params.subCategoryId};
        }

        EventFormCategory.query({
            page: 0,
            size: 100
        }, function(data) {
            vm.listCategory = data;
        }, onError);

        Principal.identity().then(function(account) {
            var authorities = (account && account.authorities) || [];
            vm.canEdit = authorities.indexOf('ROLE_EVT_EDIT') !== -1;
            vm.canValidate = authorities.indexOf('ROLE_FORM_VALIDATION') !== -1;
            vm.canBulkChange = vm.canEdit || vm.canValidate;
            angular.forEach(['DRAFT', 'SUBMITTED', 'VALIDATED', 'CONTROLLED'], function(status) {
                if ((status === 'DRAFT' || status === 'SUBMITTED') ? vm.canEdit : vm.canValidate) {
                    vm.bulkStatuses.push(status);
                }
            });
            hydrateAccessibleAreas(account);
            vm.loadAll();
        }, function() {
            vm.loadAll();
        });

        function hydrateAccessibleAreas(account) {
            var areas = (account && account.agencesRattachement) ? angular.copy(account.agencesRattachement) : [];
            if ((!areas || !areas.length) && account && account.agence) {
                areas = [angular.copy(account.agence)];
            }

            vm.allAreas = (areas || []).sort(function(left, right) {
                return String(left.nom || '').localeCompare(String(right.nom || ''));
            });
            vm.listAgency = buildAgencies(vm.allAreas);

            if ($state.params.agencyId) {
                vm.agency = findById(vm.listAgency, $state.params.agencyId);
            }
            if ($state.params.areaId) {
                vm.area = findById(vm.allAreas, $state.params.areaId);
                if (!vm.agency && vm.area && vm.area.entiteParente) {
                    vm.agency = {
                        id: vm.area.entiteParente.id,
                        nom: vm.area.entiteParente.nom
                    };
                }
            // Garder le choix « toutes les zones » lors d'une recherche explicite.
            } else if (!$state.params.search && account && account.agence) {
                vm.area = findById(vm.allAreas, account.agence.id);
                if (vm.area && vm.area.entiteParente) {
                    vm.agency = {
                        id: vm.area.entiteParente.id,
                        nom: vm.area.entiteParente.nom
                    };
                }
            }

            updateAreaFilter();
        }

        function buildAgencies(areas) {
            var byId = {};
            angular.forEach(areas || [], function(area) {
                if (!area || !area.entiteParente || !area.entiteParente.id) {
                    return;
                }
                byId[area.entiteParente.id] = {
                    id: area.entiteParente.id,
                    nom: area.entiteParente.nom
                };
            });
            return Object.keys(byId).map(function(key) {
                return byId[key];
            }).sort(function(left, right) {
                return String(left.nom || '').localeCompare(String(right.nom || ''));
            });
        }

        function findById(items, id) {
            var searchedId = String(id);
            return (items || []).find(function(item) {
                return item && String(item.id) === searchedId;
            }) || null;
        }

        function updateAreaFilter() {
            var selectedAgencyId = vm.agency ? String(vm.agency.id) : null;
            vm.listArea = (vm.allAreas || []).filter(function(area) {
                if (!selectedAgencyId) {
                    return true;
                }
                return area.entiteParente && String(area.entiteParente.id) === selectedAgencyId;
            });
            if (vm.area && !findById(vm.listArea, vm.area.id)) {
                vm.area = null;
            }
        }

        function updateSubCategory() {
            if (!vm.category || !vm.category.id) {
                vm.listSubCategory = [];
                vm.subCategory = null;
                return;
            }

            EventFormCategory.getListSubCategory({id: vm.category.id}, function(result) {
                vm.listSubCategory = result;
            }, onError);
        }

        function loadAll() {
            vm.currentSearch = true;
            vm.loading = true;
            vm.selected = {};
            vm.allMatching = false;
            vm.pageSelected = false;
            loadedFilters = currentFilters();
            EventForm.query(angular.extend({}, loadedFilters, {
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }), onLoadSuccess, function(error) {
                vm.loading = false;
                onError(error);
            });
        }

        function currentFilters() {
            return {
                searchText: vm.searchText,
                categoryId: vm.category ? vm.category.id : null,
                subCategoryId: vm.subCategory ? vm.subCategory.id : null,
                agencyId: vm.agency ? vm.agency.id : null,
                areaId: vm.area ? vm.area.id : null,
                workflowStatus: vm.workflowStatus || null,
                fromDate: vm.date ? $filter('date')(vm.date.startDate, 'yyyy-MM-dd') : null,
                toDate: vm.date ? $filter('date')(vm.date.endDate, 'yyyy-MM-dd') : null
            };
        }

        function selectedCount() {
            return vm.allMatching ? Number(vm.totalItems) : Object.keys(vm.selected).filter(function(id) {
                return vm.selected[id];
            }).length;
        }

        function togglePage() {
            angular.forEach(vm.eventForms, function(event) { vm.selected[event.id] = vm.pageSelected; });
        }

        function toggleMatching() {
            vm.selected = {};
            vm.pageSelected = false;
            // Conserver les filtres appliqués, jamais des filtres modifiés mais pas encore recherchés.
            selectionFilters = vm.allMatching ? angular.copy(loadedFilters) : null;
        }

        function openBulkStatus() {
            if (bulkModal || !vm.canBulkChange || vm.bulkBusy || vm.loading || !Number(vm.totalItems)) { return; }
            vm.bulkError = null;
            // Partager la sélection de la liste avec la fenêtre, sans ajouter de zone permanente.
            bulkModal = $uibModal.open({
                templateUrl: 'eventBulkStatus.html',
                scope: $scope,
                backdrop: 'static',
                keyboard: false
            });
            bulkModal.result.then(clearBulkModal, clearBulkModal);
        }

        function clearBulkModal() {
            bulkModal = null;
            // Une sélection globale doit toujours rester explicite dans la fenêtre de modification.
            vm.allMatching = false;
            selectionFilters = null;
        }

        function changeStatuses() {
            if (vm.bulkBusy || vm.loading || !selectedCount() || !vm.targetStatus) { return; }
            if (!angular.equals(currentFilters(), loadedFilters)) {
                vm.bulkError = $translate.instant('wamasysApp.eventForm.filtersChanged');
                AlertService.error(vm.bulkError);
                return;
            }
            if (!$window.confirm($translate.instant('wamasysApp.eventForm.confirmBulk', {count: selectedCount(), status: statusLabel(vm.targetStatus)}))) { return; }
            var payload = angular.extend({}, vm.allMatching ? selectionFilters : {}, {
                allMatching: vm.allMatching, targetStatus: vm.targetStatus, selectedVersions: {}
            });
            angular.forEach(vm.eventForms, function(event) {
                if (vm.selected[event.id]) { payload.selectedVersions[event.id] = event.documentVersion; }
            });
            vm.bulkBusy = true;
            vm.bulkError = null;
            vm.bulkResult = null;
            EventForm.bulkStatus(payload, function(result) {
                vm.bulkBusy = false;
                vm.bulkResult = result;
                if (bulkModal) { bulkModal.close(); }
                loadAll();
            }, function(error) {
                vm.bulkBusy = false;
                vm.bulkError = error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError');
                onError(error);
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onLoadSuccess(data, headers) {
            vm.loading = false;
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.eventForms = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError'));
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                searchText: vm.searchText,
                categoryId: vm.category ? vm.category.id : null,
                subCategoryId: vm.subCategory ? vm.subCategory.id : null,
                agencyId: vm.agency ? vm.agency.id : null,
                areaId: vm.area ? vm.area.id : null,
                workflowStatus: vm.workflowStatus || null,
                startDate: vm.date ? $filter('date')(vm.date.startDate, 'yyyy-MM-dd') : null,
                endDate: vm.date ? $filter('date')(vm.date.endDate, 'yyyy-MM-dd') : null
            });
        }

        function search() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'dateRecord';
            vm.reverse = false;
            vm.currentSearch = true;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchText = null;
            vm.category = null;
            vm.subCategory = null;
            vm.agency = null;
            vm.area = null;
            vm.workflowStatus = null;
            vm.listSubCategory = [];
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.currentSearch = true;
            vm.updateAreaFilter();
            vm.transition();
        }

        function statusLabel(status) {
            var labels = {
                DRAFT: $translate.instant('wamasysApp.eventForm.statuses.DRAFT'),
                SUBMITTED: $translate.instant('wamasysApp.eventForm.statuses.SUBMITTED'),
                VALIDATED: $translate.instant('wamasysApp.eventForm.statuses.VALIDATED'),
                CONTROLLED: $translate.instant('wamasysApp.eventForm.statuses.CONTROLLED'),
                DELETED: $translate.instant('wamasysApp.eventForm.statuses.DELETED')
            };
            return labels[status] || status;
        }
    }
})();
